import { useTranslation } from 'react-i18next'
import { ExternalLink } from 'lucide-react'
import { ReportKpiCard } from '@/components/relatorios/ReportKpiCard'
import { ReportShell } from '@/components/relatorios/ReportShell'
import { ReportTable } from '@/components/relatorios/ReportTable'
import { exportCsv } from '@/components/relatorios/reportUtils'
import { useAiAppointmentsReport } from '@/hooks/reports/reportHooks'
import { useReportDateRange } from '@/hooks/reports/useReportDateRange'
import { formatDateInAccountTz, formatDateTimeInAccountTz, formatTimeInAccountTz } from '@/lib/accountTimezone'

export default function AgendamentosIaReport() {
  const { t } = useTranslation('reports')
  const [range, setRange] = useReportDateRange()
  const report = useAiAppointmentsReport(range)
  const matched = report.data.filter((row) => row.contactId).length

  return (
    <ReportShell
      title={t('aiAppointments.title')}
      description={t('aiAppointments.description')}
      {...range}
      onRangeChange={setRange}
      loading={report.loading}
      error={report.error}
      empty={report.data.length === 0}
      onRetry={report.refetch}
      onExport={() => exportCsv('agendamentos-ia', report.data, [
        { label: t('fields.start'), value: (row) => row.start },
        { label: t('fields.end'), value: (row) => row.end },
        { label: t('fields.assistant'), value: (row) => row.assistant },
        { label: t('fields.event'), value: (row) => row.title },
        { label: t('fields.contact'), value: (row) => row.contact },
        { label: t('fields.phone'), value: (row) => row.phone },
        { label: t('fields.link'), value: (row) => row.htmlLink },
      ])}
    >
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
        <ReportKpiCard label={t('aiAppointments.kpiTotal')} value={report.data.length} />
        <ReportKpiCard label={t('aiAppointments.kpiMatched')} value={matched} />
      </div>
      <ReportTable
        rows={report.data}
        rowKey={(row, index) => `${row.assistant}-${row.eventId}-${index}`}
        columns={[
          { key: 'start', label: t('fields.dateTime'), render: (row) => formatDateTimeInAccountTz(row.start) },
          { key: 'assistant', label: t('fields.assistant'), render: (row) => row.assistant },
          { key: 'title', label: t('fields.event'), render: (row) => row.title },
          { key: 'contact', label: t('fields.contact'), render: (row) => row.contact },
          { key: 'phone', label: t('fields.phone'), render: (row) => row.phone },
          {
            key: 'link',
            label: '',
            align: 'right',
            render: (row) => row.htmlLink ? (
              <a href={row.htmlLink} target="_blank" rel="noreferrer" className="inline-flex text-primary" aria-label={t('aiAppointments.openEvent')}>
                <ExternalLink className="h-4 w-4" />
              </a>
            ) : null,
          },
        ]}
      />
    </ReportShell>
  )
}
